import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/src/components/navbar/navbar.tsx");
